const { default: axiosIns } = require('@/libs/axios')

const InfoService = {
  // POST - InfoApiController
  async sendContactEmail(model) {
    return axiosIns.post('/info/contact', model)
      .then(response => response.data)
  },
}

export default InfoService
